<div class="zones-drawer-container">
  <router-outlet></router-outlet>
</div>
